import { render } from "./Contents.vue?vue&type=template&id=0ddb29ea"
import script from "./Contents.vue?vue&type=script&lang=js"
export * from "./Contents.vue?vue&type=script&lang=js"

import exportComponent from "/home/viewchat/public_html/viewchat-web-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__